import { createBrowserRouter, Navigate } from "react-router"
import { ProtectedRoute } from "./components/ProtectedRoute/ProtectedRoute"
import ScrollToTop from "./components/ScrollToTop/ScrollToTop"
import AppLayout from "./layout/AppLayout"
import { OfferInfoLayout, OfferLayout } from "./layout/OfferLayout"
import RootLayout from "./layout/RootLayout"
import Dashboard from "./modules/Dashboard/Dashboard"
import Notifications from "./modules/Notifications/Notifications"
import OfferAccountNumbers from "./modules/Offer/OfferAccountNumbers"
import OfferAppointment from "./modules/Offer/OfferAppointment"
import OfferCalculator from "./modules/Offer/OfferCalculator"
import OfferCelebration from "./modules/Offer/OfferCelebration"
import OfferDocuments from "./modules/Offer/OfferDocuments"
import OfferEvaluation from "./modules/Offer/OfferEvaluation"
import OfferEvaluationError from "./modules/Offer/OfferEvaluationError"
import OfferEvaluationFailed from "./modules/Offer/OfferEvaluationFailed"
import OfferProductPage from "./modules/Offer/OfferProductPage"
import { OfferSettingsProvider } from "./modules/Offer/OfferSettingsContext"
import { OfferSignersPage } from "./modules/Offer/OfferSigners"
import OfferSoftFacts from "./modules/Offer/OfferSoftFacts"
import { OFFER_STEPS } from "./modules/Offer/OfferStepper"
import OfferSuccess from "./modules/Offer/OfferSuccess"
import OfferSummary from "./modules/Offer/OfferSummary"
import OfferWelcomePage from "./modules/Offer/OfferWelcomePage"
import Overview from "./modules/Overview/Overview"
import Profile from "./modules/Profile/Profile"
import Rectification from "./modules/Rectification/Rectification"
import UserSelection from "./modules/UserSelection/UserSelection"

const router = createBrowserRouter(
  [
    {
      path: "/",
      element: (
        <>
          <ScrollToTop />
          <RootLayout />
        </>
      ),
      children: [
        {
          path: "/user-selection",
          element: <AppLayout />,
          children: [
            {
              path: "",
              element: <UserSelection />,
            },
          ],
        },
        {
          element: (
            <ProtectedRoute>
              <AppLayout />
            </ProtectedRoute>
          ),
          children: [
            {
              path: "",
              element: <Dashboard />,
            },
            {
              path: "/dashboard",
              element: <Dashboard />,
            },
            {
              path: "/notifications",
              element: <Notifications />,
            },
            {
              path: "/profile",
              element: <Profile />,
            },
            {
              path: "/overview/:caseId",
              element: <Overview />,
            },
            {
              path: "/rectification/:caseId",
              element: <Rectification />,
            },
          ],
        },

        {
          path: "/offer",
          element: (
            <ProtectedRoute>
              <OfferSettingsProvider>
                <OfferLayout />
              </OfferSettingsProvider>
            </ProtectedRoute>
          ),
          children: [
            {
              path: `${OFFER_STEPS.Calculator}`,
              element: <OfferCalculator />,
            },
            {
              path: `${OFFER_STEPS.SoftFacts}`,
              element: <OfferSoftFacts />,
            },
            {
              path: `${OFFER_STEPS.Evaluation}`,
              element: <OfferEvaluation />,
            },
            {
              path: `${OFFER_STEPS.Signers}`,
              element: <OfferSignersPage />,
            },
            {
              path: `${OFFER_STEPS.Accounts}`,
              element: <OfferAccountNumbers />,
            },
            {
              path: `${OFFER_STEPS.Summary}`,
              element: <OfferSummary />,
            },
            {
              path: `${OFFER_STEPS.Documents}`,
              element: <OfferDocuments />,
            },
            {
              path: `${OFFER_STEPS.Appointment}`,
              element: <OfferAppointment />,
            },
            {
              path: "",
              element: <OfferProductPage />,
            },
          ],
        },

        {
          path: "offer/info",
          element: (
            <ProtectedRoute>
              <OfferSettingsProvider>
                <OfferInfoLayout />
              </OfferSettingsProvider>
            </ProtectedRoute>
          ),
          children: [
            {
              path: "welcome",
              element: <OfferWelcomePage />,
            },
            {
              path: "failed",
              element: <OfferEvaluationFailed />,
            },
            {
              path: "error",
              element: <OfferEvaluationError />,
            },
            {
              path: "status",
              element: <OfferCelebration />,
            },
            {
              path: "success",
              element: <OfferSuccess />,
            },
          ],
        },
      ],
    },

    {
      path: "*",
      element: <Navigate to="/user-selection" />,
    },
  ],
  {
    basename: import.meta.env.BASE_URL,
  },
)

export default router
